import React from 'react';

const I = ({ d, className = 'w-5 h-5' }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d={d} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const BellIcon   = (p) => <I {...p} d="M12 3a5 5 0 00-5 5v3.5L5.5 15h13L17 11.5V8a5 5 0 00-5-5zM10 18a2 2 0 004 0" />;
const SearchIcon = (p) => <I {...p} d="M11 4a7 7 0 100 14 7 7 0 000-14zM20 20l-3.5-3.5" />;
const ChatIcon   = (p) => <I {...p} d="M4 5h16v11H8l-4 4V5z" />;
const CheckIcon  = (p) => <I {...p} d="M5 12l4 4 10-10" />;

const fmtDateLong = (d = new Date()) =>
  d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });

const greeting = () => {
  const h = new Date().getHours();
  if (h < 12) return 'Good morning';
  if (h < 18) return 'Good afternoon';
  return 'Good evening';
};

const PageHeader = ({ holderName }) => {
  const greetingLine = holderName ? `${greeting()}, ${holderName}` : greeting();
  return (
    <>
      <div className="mb-4">
        <h1 className="font-serif text-[26px] leading-tight text-[#1a2b3c]">
          {greetingLine}
        </h1>
        <p className="text-[13px] text-gray-500 mt-1">{fmtDateLong()}</p>
      </div>

      <div className="flex items-center justify-between mb-5">
        <span className="inline-flex items-center gap-2 bg-[#e8f3ec] text-[#1f5c3a] text-[12px] font-medium px-3 py-1.5 rounded-full">
          <CheckIcon className="w-3.5 h-3.5" />
          Secure session
        </span>
        <button
          aria-label="Notifications"
          className="w-10 h-10 rounded-full bg-white border border-gray-200 flex items-center justify-center text-[#0b2740] hover:bg-gray-50"
        >
          <BellIcon className="w-5 h-5" />
        </button>
      </div>

      <div className="flex items-center gap-3 mb-6">
        <div className="flex-1 flex items-center gap-2 bg-white border border-gray-200 rounded-full px-4 py-2.5">
          <SearchIcon className="w-4 h-4 text-gray-400" />
          <input
            type="text"
            placeholder="Search accounts, transactions, and tools"
            className="flex-1 bg-transparent text-[13px] text-gray-700 placeholder:text-gray-400 focus:outline-none"
          />
        </div>
        <button
          aria-label="Chat"
          className="w-11 h-11 rounded-full bg-[#0b2740] text-white flex items-center justify-center hover:bg-[#12324f]"
        >
          <ChatIcon className="w-5 h-5" />
        </button>
      </div>
    </>
  );
};

export default PageHeader;